/**
 * Claimed Reward Data Model
 *
 * Represents an instance of a user claiming a reward.
 * Multiple claims per reward type are allowed.
 */
export var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["CLAIMED"] = "claimed";
    ClaimStatus["FULFILLED"] = "fulfilled";
    ClaimStatus["CANCELLED"] = "cancelled";
})(ClaimStatus || (ClaimStatus = {}));
